<template>
  <div class="row">
    <div class="col-md-12">
      <list-table :requests="requests" />

      <div
        v-if="!requests"
        class="card-disabled"
      >
        <div class="loader" />
      </div>
    </div>
  </div>
</template>

<script>
import ListTable from "@/components/ServiceTls/List";
import ServiceTls from "@/services/ServiceTls";

const data = () =>({
	requests: []
});

const fetchData = function () {
	ServiceTls.Cases.all().then(response => {
		this.requests = response.cases || [];
	});
};

export default {
	name: "ServiceTlsIndex",
	components: {
		ListTable
	},
	data,
	mounted() {
		fetchData.bind(this)();
	},
};
</script>